import {publicRequestADemoStateUniqueIdentifier} from './public-request-a-demo.model';
import {UnknownError} from '../../../shared/symbols';
import {RequestADemoForm} from '../../types';

export class SendRequestADemoForm {
  static readonly type = `${publicRequestADemoStateUniqueIdentifier} ${SendRequestADemoForm.name}`;

  constructor(public requestADemoForm: RequestADemoForm) {}
}

export class SendRequestADemoFormSuccess {
  static readonly type = `${publicRequestADemoStateUniqueIdentifier} ${SendRequestADemoFormSuccess.name}`;
}

export class SendRequestADemoFormFail {
  static readonly type = `${publicRequestADemoStateUniqueIdentifier} ${SendRequestADemoFormFail.name}`;

  constructor(public error: UnknownError) {}
}
